import { render, staticRenderFns } from "./MenuRoleSelector.vue?vue&type=template&id=65385050"
import script from "./MenuRoleSelector.vue?vue&type=script&lang=js"
export * from "./MenuRoleSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports